import { environment } from '@env/environment';

export const ToolsHelper = {
  initBackground(url: string, moreBg?: string): string {
    if (moreBg) {
      return `url('${url}'), url(${moreBg})`;
    }
    return `url('${url}')`;
  },

  removeTagsFromStr(str: string): string | null {
    return str != null
      ? str.replace(/(<([^>]+)>)/gi, '')?.replace(/&nbsp;/g, ' ')
      : null;
  },

  minLogoUrl(url: string, path: string): string {
    const position = path.indexOf('.', -1);
    const neededUrl = environment.production
      ? url
      : url.replace('-dev-', '-stage-');
    return [neededUrl, path.slice(0, position), '', path.slice(position)].join(
      '',
    );
  },

  dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl?.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const fileExt = mime.replace('image/', '');
    return new File([u8arr], `${filename}.${fileExt}`, { type: mime });
  },

  blobToBase64(blob): Promise<any> {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },
};
